import { FormActionFrameworkStep, registerStep } from '../step';
import { resolveTemplate } from '../template';
export class ShowMessageStep extends FormActionFrameworkStep {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "type", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'showMessage'
        });
        Object.defineProperty(this, "config", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {
                message: '',
                title: '',
                level: 'info',
                stopAfter: false,
            }
        });
    }
    async execute(context) {
        const rawMessage = (typeof this.config.message === 'string' && this.config.message) || '';
        const resolvedMessage = resolveTemplate(rawMessage, context);
        const text = resolvedMessage == null
            ? ''
            : typeof resolvedMessage === 'object'
                ? JSON.stringify(resolvedMessage)
                : String(resolvedMessage);
        const rawTitle = (typeof this.config.title === 'string' && this.config.title) || '';
        const resolvedTitle = rawTitle ? resolveTemplate(rawTitle, context) : null;
        const title = resolvedTitle == null || resolvedTitle === ''
            ? levelTitle(this.config.level)
            : typeof resolvedTitle === 'object'
                ? JSON.stringify(resolvedTitle)
                : String(resolvedTitle);
        const level = normalizeLevel(this.config.level);
        const display = title ? `${title}\n\n${text}` : text;
        context.log(`[showMessage] level=${level} title=${title} message=${text}`);
        if (typeof window !== 'undefined' && typeof window.alert === 'function' && display.trim()) {
            window.alert(display);
        }
        if (this.config.stopAfter === true) {
            context.shouldStop = true;
            context.log('[showMessage] stopAfter=true — shouldStop set');
        }
        return context;
    }
    showStepForm(container) {
        container.innerHTML = '';
    }
}
function normalizeLevel(level) {
    const s = typeof level === 'string' ? level.toLowerCase() : '';
    if (s === 'success' || s === 'warning' || s === 'error' || s === 'info') {
        return s;
    }
    return 'info';
}
function levelTitle(level) {
    switch (normalizeLevel(level)) {
        case 'success':
            return 'Success';
        case 'warning':
            return 'Warning';
        case 'error':
            return 'Error';
        default:
            return 'Message';
    }
}
registerStep('showMessage', ShowMessageStep);
